import { useDispatch, useSelector } from "react-redux";
import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { StringUtils } from "../../../../../core/utils/string_utils";
import { galleryActions } from "../../../di/di";

export const GalleryPhotoViewerComponent = () => {
  const dispatch = useDispatch();

  /// Multiple Images Selectors
  const mediaItems = useSelector((state) => state.gallery.images);
  const showImageViewer = useSelector((state) => state.gallery.showImageViewer);
  const viewerImageIndex = useSelector(
    (state) => state.gallery.viewerImageIndex
  );

  /// Single Image Selectors
  const showSingleImageViewer = useSelector(
    (state) => state.gallery.showSingleImageViewer
  );
  const singleImageUrl = useSelector((state) => state.gallery.singleImageUrl);

  return (
    <>
      {/* Multiple Images Viewer */}
      <PhotoSlider
        visible={showImageViewer}
        images={mediaItems.map((item) => ({
          src: item.imageUrl,
          key: item.id - StringUtils.generateRandomCharacters(),
        }))}
        onClose={() => dispatch(galleryActions.hidePhotoViewer())}
        index={viewerImageIndex}
        onIndexChange={(index) =>
          dispatch(galleryActions.photoViewerSetIndex({ index }))
        }
      />

      {/* Single Image Viewer */}
      <PhotoSlider
        visible={showSingleImageViewer}
        images={[
          {
            src: singleImageUrl,
            key: singleImageUrl - StringUtils.generateRandomCharacters(),
          },
        ]}
        onClose={() => dispatch(galleryActions.hidePhotoViewer())}
      />
    </>
  );
};
